import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { NgForm } from '@angular/forms';
import { LoaderService } from '@arianeeprivate/wallet-shared-components';
import { ArianeeApiService } from '../../../../../providers/arianee-api-service/arianee-api.service';
import { AlertController } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';
import { EventLoggerService } from '../../../../../providers/event-logger/event-logger-service';

@Component({
  selector: 'app-ask-for-brand-form',
  templateUrl: './ask-for-brand-form.component.html',
  styleUrls: ['./ask-for-brand-form.component.scss']
})
export class AskForBrandFormComponent implements OnInit {
  brandName: string;
  @Output() saved = new EventEmitter<string>();

  constructor (
      private loaderService: LoaderService,
      private arianeeApiService: ArianeeApiService,
      private alertController: AlertController,
      private translateService:TranslateService,
      private eventLoggerSerivce:EventLoggerService
  ) { }

  ngOnInit () {
    this.eventLoggerSerivce.logScreen('ask-for-brand-form');
  }

  private displayError=async () => {
    const header = this.translateService.instant('ArianeeBrandsList.error.title');
    const message = this.translateService.instant('ArianeeBrandsList.error.message');
    const alertButton = this.translateService.instant('ArianeeBrandsList.error.button');

    const alert = await this.alertController.create({
      header,
      message,
      buttons: [alertButton]
    });

    await alert.present();
  }

  /**
   * Save new Brand request and submit saved Output Event
   * @param form: Ask-for-Brand Form
   */
  submit (form: NgForm): void {
    this.eventLoggerSerivce.logEvent('ask-for-brand-form_submit');
    if (form.valid) {
      this.loaderService.showLoader();

      this.arianeeApiService.askForNewBrand(this.brandName)
        .subscribe(() => {
          this.eventLoggerSerivce.logEvent('ask-for-brand-form_submit_success');

          this.saved.emit(this.brandName);
          this.loaderService.dismiss();
        }, () => {
          this.eventLoggerSerivce.logEvent('ask-for-brand-form_submit_error');
          this.loaderService.dismiss();
          this.displayError();
        });
    }
  }
}
